import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import React from 'react';
import { capitalize } from 'lodash';
import FieldGroup from '../../FieldGroup.jsx';

const groupStakeholderFieldKeys = ['name', 'email'];

const GroupStakeholderFields = ({
  onUpdateStakeholderField,
  stakeholdersStructure,
  index,
  onDeleteStakeholder,
}) => {
  return (
    <Row>
      {groupStakeholderFieldKeys.map((key) => (
        <Col xs={3} key={index + key}>
          <Field
            name={`groupField.${index}.${key}`}
            placeholder={`Enter ${capitalize(key)}`}
            type="text"
          >
            {(props) => (
              <FieldGroup
                {...props}
                value={stakeholdersStructure[index][key]}
                onChange={(event) =>
                  onUpdateStakeholderField(index, key, event.target.value)
                }
                validateWithoutTouched={!!stakeholdersStructure[index][key]}
              />
            )}
          </Field>
        </Col>
      ))}
      <Col xs={1}>
        <Button
          bsStyle="default"
          className="btn-delete"
          onClick={() => onDeleteStakeholder(index)}
        >
          Delete
        </Button>
      </Col>
    </Row>
  );
};

export default GroupStakeholderFields;
